'use strict';

var FIELDS = 'input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]), select, textarea';
var NAVIGATION_KEYS = [
    'Tab', 'Shift', 'Control', 'Alt', 'Meta', 'Escape', 'Enter', ' ',
    'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight',
    'Home', 'End', 'PageUp', 'PageDown'
];

module.exports = function initFieldFocusRing() {
    function markPointer(event) {
        var field = event.target && event.target.closest && event.target.closest(FIELDS);

        if (field) {
            field.setAttribute('data-pointer-focus', '');
        }
    }

    document.addEventListener('mousedown', markPointer, true);
    document.addEventListener('touchstart', markPointer, true);

    document.addEventListener('keydown', function (event) {
        if (NAVIGATION_KEYS.indexOf(event.key) !== -1) {
            return;
        }

        var active = document.activeElement;

        if (active && active.matches && active.matches(FIELDS)) {
            active.setAttribute('data-typing', '');
        }
    }, true);

    document.addEventListener('focusout', function (event) {
        var field = event.target;

        if (field && field.removeAttribute) {
            field.removeAttribute('data-typing');
            field.removeAttribute('data-pointer-focus');
        }
    }, true);
};
